import React, { Fragment, useState, useEffect } from 'react'
import {
  ChipField,
  Create,
  SimpleForm,
  TextInput,
  CardActions,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  CheckboxGroupInput,
} from 'react-admin'

import { makeStyles } from '@material-ui/core/styles'
import SectionTitle from '../components/SectionTitle'
import ModalityDualListBox from '../components/ModalityDualListBox'
import { NOTIFICATION_PREFERENCES } from '../constants'
import * as storage from '../lib/storage'
import { useUser } from '../hooks'

const useStyles = makeStyles((theme) => ({
  title: { width: 500 },
  textInput: { width: 500 },
  latitude: { display: 'inline-block', width: 237 },
  longitude: { display: 'inline-block', width: 237, marginLeft: 25 },
  search: { marginLeft: theme.spacing(2) },
  chipInput: { width: 500, marginBottom: theme.spacing(3) },
}))

const ActionsRefresh = () => <CardActions />

const rules = [
  { id: 'GY', name: 'Green to Yellow' },
  { id: 'GR', name: 'Green to Red' },
  { id: 'YG', name: 'Yellow to Green' },
  { id: 'YR', name: 'Yellow to Red' },
  { id: 'RG', name: 'Red to Green' },
  { id: 'RY', name: 'Red to Yellow' },
  { id: 'A', name: 'Any' },
]

const triggers = [
  { id: 'health', name: 'Health Status' },
  { id: 'time', name: 'Last Reported Time' },
]

const AlertCreate = ({ permissions, ...props }) => {
  const [accountId, setAccountId] = useState()
  const classes = useStyles()
  const { isSuperadmin } = useUser()

  useEffect(() => {
    const id = storage.get('accountId')
    setAccountId(id)
  }, [])

  return (
    <Fragment>
      <br />
      <Create {...props} actions={<ActionsRefresh />}>
        <SimpleForm>
          <SectionTitle label="Alert details" />

          {isSuperadmin && (
            <ReferenceInput
              fullWidth
              source="accountId"
              reference="accounts"
              formClassName={classes.textInput}
            >
              <SelectInput defaultValue={accountId} source="name" />
            </ReferenceInput>
          )}

          <TextInput source="title" formClassName={classes.textInput} fullWidth />

          <ModalityDualListBox
            source="modalityIds"
            label="Modalities"
            selectedLabel="Included in alert"
          />

          <ReferenceArrayInput
            fullWidth
            reference="users"
            source="userIds"
            formClassName={classes.textInput}
          >
            <SelectArrayInput addLabel label="Users to notify" optionText="name">
              <ChipField source="name" />
            </SelectArrayInput>
          </ReferenceArrayInput>

          <SelectInput
            fullWidth
            label="Alert Trigger"
            defaultValue="health"
            choices={triggers}
            source="trigger"
            formClassName={classes.textInput}
          />

          <SelectArrayInput
            label="Transition Rules"
            source="transitions"
            choices={rules}
            className={classes.textInput}
          />

          <CheckboxGroupInput
            label="Notification preferences"
            source="notifications"
            choices={NOTIFICATION_PREFERENCES}
          />
        </SimpleForm>
      </Create>
      <br />
      <br />
    </Fragment>
  )
}

export default AlertCreate
